const query = gql`
  query NutritionRecipe($slug: String!, $locale: SiteLocale) {
    nutritionRecipe(filter: { slug: { eq: $slug } }, locale: $locale) {
      id
      slug
      recipeName
      intro
      image {
        responsiveImage(imgixParams: { w: 800, h: 600, fit: crop }) {
          srcSet
          webpSrcSet
          sizes
          src
          alt
          title
          base64
          width
          height
        }
      }
      time
      servings
      calories
      instructions {
        instruction
        id
      }
      ingredients {
        __typename
        ... on IngredientBlockRecord {
          id
          ingredientUs
          ingredientMetric
          ingredientName
        }
        ... on LegacyIngredientRecord {
          id
          ingredient
        }
      }
      categories {
        id
        name
        slug
      }
      meta: _seoMetaTags {
        tag
        content
        attributes
      }
    }
  }
`

export { query }
